import { render, staticRenderFns } from "./KeyIndicatorHs.vue?vue&type=template&id=2ab5bc95&scoped=true"
import script from "./KeyIndicatorHs.vue?vue&type=script&lang=js"
export * from "./KeyIndicatorHs.vue?vue&type=script&lang=js"
import style0 from "./KeyIndicatorHs.vue?vue&type=style&index=0&id=2ab5bc95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5bc95",
  null
  
)

export default component.exports